import VenueBasedProductsRepository from "@app-contexts/dashboard/features/products/data/repositories/VenueBasedProductsRepository";
import PublicBasedProductsRepository from "@app-contexts/public/features/products/data/repositories/PublicBasedProductsRepository";
import { ProductVariantSerializer } from "@app-contexts/public/features/products/data/types/products";
import { ITEM_TYPES_MAP } from "@shared/constants/enums";
import { useAnalyticsContext } from "@shared/contexts/AnalyticsContext/useAnalyticsContext";
import useAnalytics from "@shared/lib/analytics/hooks/useAnalytics";
import { GtagItemType } from "@shared/lib/analytics/types/analytics-types";
import { UseModelServiceType } from "@shared/services/api/hooks/useModelService";
import { useEffect } from "react";

export default function useItemGroupProduct(
  productId: number,
  productAttribute: number | undefined,
  productService: () => UseModelServiceType<
    VenueBasedProductsRepository | PublicBasedProductsRepository
  >,
  updateTrackingBasketData: ((input: GtagItemType) => void) | undefined,
  itemGroupId?: number
) {
  const { enableAnalytics } = useAnalyticsContext();
  const analytics = useAnalytics();

  const { useRetrieve } = productService();

  const { data: productData, isFetching } = useRetrieve(productId, {
    options: {
      enabled: Boolean(productId),
    },
  });

  useEffect(() => {
    // propagates fetched data up to the public checkout context
    // so the data can be used for GTAG tracking
    // Note: updateTrackingBasketData is only used in the public checkout context
    if (productData && productAttribute && updateTrackingBasketData) {
      const productInBasket = (
        productData.product_attributes as ProductVariantSerializer[]
      ).find((pa) => pa.id === productAttribute);

      if (productInBasket && enableAnalytics) {
        const trackingData = analytics.formatGtagTrackingData(
          Number(itemGroupId),
          productData.name,
          productInBasket?.name,
          ITEM_TYPES_MAP.ITEM_TYPE_PRODUCT.id
        );
        updateTrackingBasketData(trackingData);
      }
    }
  }, [productData, productAttribute, updateTrackingBasketData]);

  return { productData, isFetching };
}
